var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Fade, SideImageLayout, StandardLayout } from 'hx-ui';
import { useSetProgress } from 'hx-progress';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { StyledProgress } from '@/components/styled-progress.component';
import { useLocation } from 'react-router-dom';
var eventMap = {
    '/setup/volume': 'volume',
    '/setup/info': 'tip',
};
function Nav() {
    var pathname = useLocation().pathname;
    var eventName = eventMap[pathname];
    return (_jsxs(NavigationButtonsContainer, __assign({ className: "pb-6 pt-4" }, { children: [_jsx(NavigationButton, { analyticsEvent: eventName && "".concat(eventName, "_previous"), type: "back", variant: "outlined", label: "Previous" }), _jsx(NavigationButton, { analyticsEvent: eventName && "".concat(eventName, "_next"), type: "submit", label: "Next" })] })));
}
export var StepLayout = function (_a) {
    var image = _a.image, heading = _a.heading, headingComponent = _a.headingComponent, subHeading = _a.subHeading, content = _a.content, info = _a.info, _b = _a.nav, nav = _b === void 0 ? _jsx(Nav, {}) : _b, progress = _a.progress;
    useSetProgress(progress === null || progress === void 0 ? void 0 : progress.phase, progress === null || progress === void 0 ? void 0 : progress.step);
    return (_jsx(SideImageLayout, { className: 'overflow-y-auto', leftPanelWidth: "40%", header: _jsx(StyledProgress, { className: "px-4 md:px-12 py-6", textClassName: 'font-bold' }), headingComponent: headingComponent, imageLeft: image, imageStyle: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        }, content: _jsx(StandardLayout, { contentHeader: heading ? (_jsxs(Fade, __assign({ className: "grid px-6 gap-5 md:pt-8 justify-center items-end min-h-[6rem] mx-auto" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl" }, { children: heading })), _jsx(Typography, __assign({ className: "text-xl" }, { children: subHeading }))] }))) : undefined, content: _jsx(Fade, __assign({ delay: 0.1, className: "grid md:pt-6 place-items-center" }, { children: content })), contentFooter: _jsx(Fade, __assign({ delay: 0.2, className: "grid gap-4 px-6 py-4 place-items-center" }, { children: info })) }), nav: nav }));
};
